import { borderStyleGray, Table } from "../../reportingHelpers.jsx";
import React from "react";
import { Text, View } from "@react-pdf/renderer";

const getDefenders = (playByPlay, teams, teamId) => {
  const shootOutDefenceEvents = playByPlay.filter(
    (e) => ["shootOutDefence"].includes(e.eventType)
      && ["made", "conceded", "missed", "saved"].includes(e.subType)
      && e.entityId === teamId
  );
  let goalkeepers = shootOutDefenceEvents.map(e => e.personId);
  const unique = goalkeepers.filter((item, index) => goalkeepers.indexOf(item) === index);
  goalkeepers = unique.map(goalkeeperId => {
    return teams[teamId].players.find(p => p.personId === goalkeeperId);
  });

  return goalkeepers;
};

const TableRows = ({ data }) => {
  return data.map((defender, index) => (
    <View key={index} style={{ flexDirection: "row", borderTop: borderStyleGray, fontSize: 10 }}>
      <View style={{ flexBasis: "11%", alignItems: "center", borderRight: borderStyleGray }}>
        <Text>{defender.bib}</Text>
      </View>
      <View style={{ flexBasis: "89%", alignItems: "flex-start", paddingLeft: 2 }}>
        <Text>{defender.personFullName}</Text>
      </View>
    </View>
  ));
};

const DefendersTable = ({ intl, data }) => {
  return <Table style={{ border: borderStyleGray, flexBasis: "47%" }}>
    <View style={{ flexDirection: "row" }}>
      <View style={{ alignItems: "center", flexBasis: "11%", borderRight: borderStyleGray }}>
        <Text>
          {intl.formatMessage({
            id: "reports.shootoutReport.shirtNumber",
            defaultMessage: "Shirt #",
          })}
        </Text>
      </View>
      <View style={{ alignItems: "center", flexBasis: "89%" }}>
        <Text>
          {intl.formatMessage({
            id: "reports.shootoutReport.defender",
            defaultMessage: "Defender",
          })}
        </Text>
      </View>
    </View>
    <TableRows data={data}/>
  </Table>;
};

const TeamShootoutDefenders = ({ intl, playByPlay, teams, homeTeamId, awayTeamId }) => {
  return <View style={{ marginBottom: 6 }}>
    <Text style={{ fontSize: "12", fontWeight: "bold", textAlign: "center", marginBottom: 6 }}>
      {intl.formatMessage({
        id: "reports.shootoutReport.defenders",
        defaultMessage: "Defenders",
      })}
    </Text>
    <View
      style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start" }}
    >
      <DefendersTable intl={intl} data={getDefenders(playByPlay, teams, homeTeamId)}/>
      <DefendersTable intl={intl} data={getDefenders(playByPlay, teams, awayTeamId)}/>
    </View>
  </View>;
};

export default TeamShootoutDefenders;
